import React, { Suspense, lazy } from "react";

const DestinationCTR = lazy(() => import("../containers/destination/DestinationCTR"));

function Tour() {
  return (
    <div>
      <Suspense
        fallback={
          <div className="flex items-center justify-center h-screen bg-white">
            <div className="w-16 h-16 border-4 border-t-[#ff9219] border-gray-200 rounded-full animate-spin"></div>
          </div>
        }
      >
        <DestinationCTR />
      </Suspense>
    </div>
  );
}

export default Tour;
